import {
    ApartmentBuildingStatus,
    calculateDifferenceInDays,
    ProjectPhaseStatus,
    PropertyTypeStatus,
} from '@bpd-library/utilities';
import { View, ViewData } from '@features/properties/store';

const PROPERTY_TYPE_VIEW_SORTING: (
    | ProjectPhaseStatus
    | ApartmentBuildingStatus
    | PropertyTypeStatus
)[] = [
    'OnSale',
    'SaleStarted',
    'SaleSoon',
    'InPreparation',
    'ForRent',
    'AmountAvailable',
    'AssigningOn',
    'InOption',
    'Sold',
    'Rented',
    'UnderConstruction',
];

function sortData(view: View) {
    switch (view.type) {
        case 'apartmentConstructionNumber':
        case 'constructionNumber':
            sortConstructionNumberView(view.data);
            break;
        case 'apartmentPropertyType':
        case 'propertyType':
            sortPropertyTypeView(view.data);
            break;
    }
}

function sortConstructionNumberView(data: ViewData) {
    data.sort((a, b) => {
        if (a.objectType !== 'constructionNumber' || b.objectType !== 'constructionNumber') {
            return 0;
        }

        if (!a.status || a.status === 'Reserved') return -1;

        if (!b.status || b.status === 'Reserved') return 1;

        if (
            a.status === 'AssigningOn' &&
            b.status === 'AssigningOn' &&
            a.projectPhase?.allocationDate &&
            b.projectPhase?.allocationDate
        ) {
            const millisecondsA = new Date(a.projectPhase.allocationDate).valueOf();
            const millisecondsB = new Date(b.projectPhase.allocationDate).valueOf();
            return millisecondsA - millisecondsB;
        }

        return (
            PROPERTY_TYPE_VIEW_SORTING.indexOf(a.status) -
            PROPERTY_TYPE_VIEW_SORTING.indexOf(b.status)
        );
    });
}

function sortPropertyTypeView(data: ViewData) {
    data.sort((a, b) => {
        if (a.objectType === 'constructionNumber' || b.objectType === 'constructionNumber')
            return 0;

        if (!a.status) return -1;
        if (!b.status) return 1;

        const aIndex = PROPERTY_TYPE_VIEW_SORTING.indexOf(a.status);
        const bIndex = PROPERTY_TYPE_VIEW_SORTING.indexOf(b.status);

        // If both objects have the same index (status), apply extra sorting logic
        if (aIndex === bIndex) {
            if (a.objectType !== 'projectPhase' && a.objectType === b.objectType) {
                // If object types are equal, sort by nearest sale start date
                if (!a.projectPhase?.saleStartDate) return 1;
                if (!b.projectPhase?.saleStartDate) return -1;

                const now = new Date();

                const aSaleStartDifference = calculateDifferenceInDays(
                    now,
                    new Date(a.projectPhase.saleStartDate),
                );
                const bSaleStartDifference = calculateDifferenceInDays(
                    now,
                    new Date(b.projectPhase.saleStartDate),
                );

                return aSaleStartDifference < bSaleStartDifference ? -1 : 1;
            } else {
                // If not, sort apartmentBuildings first
                return a.objectType === 'apartmentBuilding' ? -1 : 1;
            }
        } else {
            return aIndex < bIndex ? -1 : 1;
        }
    });
}

export { sortData };
